import React, { useEffect, useState } from 'react';
import api from '../api/questions';

const Leaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const response = await api.get('/api/auth/leaderboard');

        // Vérifier que Elo et RD sont valides
        const validUsers = response.data.filter(
          (user) => !isNaN(user.elo) && !isNaN(user.RD)
        );
        setLeaderboard(validUsers); // Les données sont triées par défaut dans le backend
      } catch (err) {
        console.error('Erreur lors de la récupération du classement :', err.message);
        setError('Erreur lors de la récupération du classement');
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, []);

  if (loading) {
    return <p style={{ textAlign: 'center' }}>Chargement du classement...</p>;
  }

  if (error) {
    return <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>;
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Classement des Utilisateurs</h1>
      <table style={{ margin: '0 auto', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid black', padding: '5px' }}>Position</th>
            <th style={{ border: '1px solid black', padding: '5px' }}>Email</th>
            <th style={{ border: '1px solid black', padding: '5px' }}>Elo</th>
            <th style={{ border: '1px solid black', padding: '5px' }}>RD</th>
          </tr>
        </thead>
        <tbody>
          {leaderboard.map((user, index) => (
            <tr key={user.id}>
              <td style={{ border: '1px solid black', padding: '5px' }}>{index + 1}</td>
              <td style={{ border: '1px solid black', padding: '5px' }}>{user.email}</td>
              <td style={{ border: '1px solid black', padding: '5px' }}>{Math.round(user.elo)}</td>
              <td style={{ border: '1px solid black', padding: '5px' }}>{Math.round(user.RD)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Leaderboard;
